import React, { useState } from 'react';
import {
  Box,
  Drawer,
  IconButton,
  useMediaQuery,
  Typography,
  AppBar,
  Toolbar,
} from '@mui/material';
import { ChevronLeftOutlined, Menu } from '@mui/icons-material';
import { Navigate,  useNavigate } from 'react-router-dom';
import TopNav from '../v2/TopNav/TopNav';
import Header from '../v2/TopNav/Header';

const GlobalWrapper = ({
  children,
  SidebarComponent = null,
  sidebarProps = {},
  sidebarTitle = null,
  isPwa = false,
  backroute = null,
}) => {
  const navigate = useNavigate();

  const token = localStorage.getItem('token');
  const isMobile = useMediaQuery('(max-width: 1200px)');
  const [open, setOpen] = useState(false);

  const toggleDrawer = () => {
    setOpen(!open);
  };
  if (!token) {
    return <Navigate to='/' />;
  }
  const navigationTarget = backroute ? backroute : -1 ;
  return (
    <>
      {/* {!isPwa && <TopNav />} */}
      <Header />
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' } }}>
        {SidebarComponent && isMobile && sidebarTitle && (
          <>
            <AppBar  position="sticky" color="default" elevation={1} sx={{ backgroundColor: 'white', zIndex: 1060, boxShadow: 'none' }}>
              <Toolbar sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} >
                <ChevronLeftOutlined  onClick={() => navigate(navigationTarget)} sx={{ cursor: 'pointer'}} />
                <Typography variant='h6' sx={{ color: 'black', fontWeight: 'bold' }}>{sidebarTitle}</Typography>
                <IconButton edge="end" onClick={toggleDrawer}><Menu /></IconButton>
              </Toolbar>
            </AppBar>
            <Drawer
              anchor='left'
              open={open}
              onClose={toggleDrawer}
            >
              <SidebarComponent {...sidebarProps} closeDrawer={toggleDrawer} />
            </Drawer>
          </>
        )}
        {SidebarComponent && !isMobile && (
          <>
            <Box sx={{ width: '18%', height: '100vh', overflowY: 'auto' }}>
              {SidebarComponent && <SidebarComponent {...sidebarProps} />}
            </Box>
          </>
        )}
        <Box
          sx={{
            width: isMobile || !SidebarComponent ? '100%' : '82%',
            height: {xs: 'calc(100vh + (-56px))', lg: 'auto'},
            // height:'calc(100vh + (-56px))',
            overflowY: 'auto',
            display: 'block',
            backgroundColor: '#f7f7f7',
            position: isMobile ? 'fixed' : 'relative',
            top: isMobile ? '56px' : 0,
            left: 0,
            right: 0,
            zIndex: isMobile ? 1000 : 'auto',
          }}
        >
         {!isMobile && sidebarTitle && (
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                py: 2,
                px: 2,
              }}
            >
              <ChevronLeftOutlined onClick={() => navigate(navigationTarget)} fontSize={'large'} sx={{ cursor: 'pointer'}} />
              <Typography variant="h6" sx={{ color: 'black', fontWeight: 'bold', ml: 3 }}>
                {sidebarTitle}
              </Typography>
            </Box>
          )}
          
          {children}
        </Box>  
      </Box>
    </>
  );
};

export default GlobalWrapper;
